import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/model.png'


const _hoisted_1 = { class: "model-wrapper" }

import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";

import DataManage from "@/assets/img/dataManage.png";
import ModelManage from "@/assets/img/modelManage.png";
import PersonManage from "@/assets/img/personManage.png";
import MessagePush from "@/assets/img/messagePush.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'modelCycle',
  setup(__props) {

const route = useRoute();

const functionList = [
  {
    name: "数据管理",
    imgSrc: DataManage,
  },
  {
    name: "模型管理",
    imgSrc: ModelManage,
  },
  {
    name: "人群圈选",
    imgSrc: PersonManage,
  },
  {
    name: "精准推送",
    imgSrc: MessagePush,
  },
];

onMounted(() => {
  //
});

onUnmounted(() => {
  //
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "title" }, "基于算法模型的售后线索挖掘转化", -1),
    _createElementVNode("div", { class: "img-wrapper" }, [
      _createElementVNode("img", { src: _imports_0 })
    ], -1)
  ])))
}
}

})